

const WelcomeText = () => {
  return (<>
    <div>
      <img src={require('../../../../../../assets/images/curve-group.png')} alt="image" />
      <img src={require('../../../../../../assets/images/tilted-logo.png')} alt="image" style={{ position: 'absolute', top: '0', right: '0' }} />
    </div>
    <h1 className="freeman-title">Freeman</h1>
    <div className="title-underline"></div>
    <div className="welcome-text">Welcome to Freeman Recruitment Drive</div>

    <div className="registration-section">
      <h3 className="complete-registration">Complete the Registration</h3>
      <div className="curved-underline"></div>
    </div>

    <p className="steps-text">In Just Few Steps</p>
  </>)
}


export default WelcomeText;